import { defineMessages } from 'react-intl';

const messages = defineMessages({
  inputClampedHint: {
    id: 'filterRangeSlider.inputClampedHint',
    defaultMessage:
      'Wir haben deine Eingabe angepasst, um dir Artikel in unserem Sortiment zeigen zu können.',
    description: 'hint text shown if an input value is clamped',
  },
  maxValueHint: {
    id: 'filterRangeSlider.maxValueHint',
    defaultMessage: 'maximal {max} {unit}',
    description: 'max value hint text',
  },
  minValueHint: {
    id: 'filterRangeSlider.minValueHint',
    defaultMessage: 'minimal {min} {unit}',
    description: 'max value hint text',
  },
  rangeSliderLabelFrom: {
    id: 'filterRangeSlider.labelFrom',
    defaultMessage: 'von',
    description: 'input label text for from input',
  },
  rangeSliderLabelTo: {
    id: 'filterRangeSlider.labelTo',
    defaultMessage: 'bis',
    description: 'input label text for to input',
  },
  rangeSliderChipLabel: {
    id: 'filterRangeSlider.chipLabel',
    defaultMessage: '{value} {unit}',
    description: 'label text for the min and max value chip',
  },
  maxValueAriaLabel: {
    id: 'filterRangeSlider.maxValueAriaLabel',
    defaultMessage: 'Ausgewählter Preis {value} {unit}, verfügbarer Maximalpreis {max} {unit}',
    description: 'a11y label text for the max value slider thumb',
  },
  minValueAriaLabel: {
    id: 'filterRangeSlider.minValueAriaLabel',
    defaultMessage: 'Ausgewählter Preis {value} {unit}, verfügbarer Minimalpreis {min} {unit}',
    description: 'a11y label text for the min value slider thumb',
  },
});

export { messages };
